<template>
  <div class="cn-promotions">
    <div class="container">
      <h2 class="cn-promotions__title">
        {{ $t('promotions') }}
      </h2>
      <swiper-container slides-per-view="auto" space-between="16">
        <swiper-slide v-for="(promotion, i) in data.items" :key="i">
          <div class="cn-promotions__promotion">
            <CdnImg
              v-if="promotion.image && promotion.image.path"
              :src="promotion.image && promotion.image.path"
              format="webp"
              loading="lazy"
              :width="338"
              :height="225"
              :alt="promotion.title"
            />
            <div class="cn-promotions__promotion-text">
              <h3 class="cn-promotions__promotion-title">
                {{ promotion.title }}
              </h3>
              <p
                v-if="promotion.description"
                class="cn-promotions__promotion-description"
              >
                {{ promotion.description }}
              </p>
              <UiLink
                :to="`/promo/${promotion.slug}`"
                class="cn-promotions__promotion-link"
              >
                <span> {{ $t('more') }} </span>
                <UiIcon name="chevron-right" />
              </UiLink>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiLink from '@/components/ui/UiLink';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  data: {
    items: {
      img?: string;
      title: string;
      description?: string;
      image?: any;
      slug?: string;
    }[];
  };
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-promotions {
  --ab-canyon-promotions-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-promotions-title-color-text: var(--ab-canyon-color-primary);
  --ab-canyon-promotions-promotion-link-color-text: var(
    --ab-canyon-color-accent
  );
  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);

  > .container {
    position: relative;
  }

  &__title {
    color: var(--ab-canyon-promotions-title-color-text);
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: var(--size-xl);
    @media (min-width: 656px) {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }
  &__promotion {
    color: var(--ab-canyon-promotions-color-text);
    img {
      width: 100%;
    }
  }
  &__promotion-text {
    margin-top: var(--size-xl);
  }
  &__promotion-title {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  &__promotion-description {
    max-width: calc(20 * var(--size-base));
    margin-top: calc(var(--size-base) / 2);
  }
  &__promotion-link {
    color: var(--ab-canyon-promotions-promotion-link-color-text);
    display: inline-block;
    margin-top: var(--size-base);
    .cn-icon {
      width: var(--size-base);
      height: var(--size-base);
      display: inline;
    }
  }

  swiper-slide {
    width: 280px;
    @media (min-width: 1024px) {
      width: 338px;
    }
  }
}
</style>
